/**
 * BACKEND DEPENDENCY: no endpoint for the current user's RecordFlow expenses
 * (summary, transactions, documents) is confirmed yet. Replace the body with
 * the real request once the backend contract exists, resolving to
 * `{ data: { summary, transactions, documents } }`.
 * Until then this rejects instead of returning mock data.
 */
export function fetchUserExpenses() {
  return Promise.reject(
    new Error('Expenses endpoint is not available on the backend yet'),
  );
}
